import React, { useState } from "react";

const PaymentModal = ({ show, bill, onConfirm, onCancel }) => {
    const [amountPaid, setAmountPaid] = useState("");

    if (!show || !bill) return null;

    const handleSubmit = () => {
        if (!amountPaid || isNaN(amountPaid) || Number(amountPaid) < 0) {
            alert("Please enter a valid amount");
            return;
        }
        onConfirm(Number(amountPaid));
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-lg shadow-lg w-full max-w-md">
                {/* Header */}
                <div className="flex justify-between items-center p-4 border-b">
                    <h3 className="text-lg font-semibold">Record Payment</h3>
                    <button
                        onClick={onCancel}
                        className="text-gray-500 hover:text-gray-700"
                    >
                        ✕
                    </button>
                </div>

                {/* Body */}
                <div className="p-4 space-y-3">
                    <p>
                        <strong>Bill ID:</strong> {bill.id}
                    </p>
                    <p>
                        <strong>Customer:</strong> {bill.customer.name}
                    </p>
                    <p>
                        <strong>Final Amount:</strong> ₹{bill.finalAmount.toFixed(2)}
                    </p>
                    <input
                        type="number"
                        value={amountPaid}
                        onChange={(e) => setAmountPaid(e.target.value)}
                        className="w-full border rounded px-3 py-2"
                        placeholder="Enter amount paid"
                    />
                </div>

                {/* Footer */}
                <div className="flex justify-end space-x-2 p-4 border-t">
                    <button
                        onClick={onCancel}
                        className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600 transition-colors"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleSubmit}
                        className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600 transition-colors"
                    >
                        Confirm Payment
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PaymentModal;
